export { default } from './sound-switch'
